import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// `border-surface` / `border-chip` are custom width utilities. Unregistered,
// tailwind-merge reads them as border colours and drops the `border-ink` next
// to them (or, the other way round, a colour override drops the width).
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "border-w": ["border-surface", "border-chip"],
    },
  },
});

/** Joins conditional classes and resolves conflicting Tailwind utilities. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
